exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "img{max-width:100%}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-6f151b1d","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Info.vue
// module id = 81
// module chunks = 0